<script setup lang="ts">
import { VIcons } from '@/shared/ui'

const model = defineModel<boolean | undefined>()

defineProps({
  icon: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <VTooltip location="top" :text="tooltip">
    <template #activator="{ props: tipProps }">
      <VCheckbox
        class="invent-object-types-fields__flag"
        v-bind="tipProps"
        v-model="model"
        :readonly="readonly"
        density="compact"
        hide-details
      >
        <template #label>
          <VIcons :type="icon" />
        </template>
      </VCheckbox>
    </template>
  </VTooltip>
</template>
